/**
 * @generated SignedSource<<1eaf48a48c54275055a746094abe6a71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptDismissPopoverAcceptMutation$variables = {
  actionItemIds: ReadonlyArray<string>;
};
export type AcceptDismissPopoverAcceptMutation$data = {
  readonly acceptAiActionItems: {
    readonly ok: boolean | null;
  } | null;
};
export type AcceptDismissPopoverAcceptMutation = {
  response: AcceptDismissPopoverAcceptMutation$data;
  variables: AcceptDismissPopoverAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actionItemIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "actionItemIds",
        "variableName": "actionItemIds"
      }
    ],
    "concreteType": "AcceptAiActionItems",
    "kind": "LinkedField",
    "name": "acceptAiActionItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptDismissPopoverAcceptMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptDismissPopoverAcceptMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f064c94f8f68150485fc62151ef18715",
    "id": null,
    "metadata": {},
    "name": "AcceptDismissPopoverAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptDismissPopoverAcceptMutation(\n  $actionItemIds: [ID!]!\n) {\n  acceptAiActionItems(actionItemIds: $actionItemIds) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c460022f9259b8d0f1277f053feb91c";

export default node;
